import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import RegisterModal from '../RegisterModal';
import { useGlobal } from '../../contexts/globalContext';

// CA001 / RN004 / RN005 — Fluxo 1: assim que um usuário Vale Viagem (ainda não consumido)
// entrar autenticado no portal, abre o modal de vinculação SEM permitir fechar.
// Único caminho é completar cadastro ou login para transferir os pontos.
// Para convidados, o modal continua sendo disparado apenas nos pontos de produto/checkout.
const ROUTES_SEM_GATE = ['/login', '/guest', '/sso', '/session-expires'];

// Pequeno delay para a página de fundo pintar antes do modal aparecer —
// evita a sensação de "modal sem nada atrás" quando o login é instantâneo.
const REVEAL_DELAY_MS = 450;

function VoucherIdentificationGate() {
	const { user, signed, globalLoader } = useGlobal();
	const location = useLocation();
	const [reveal, setReveal] = useState(false);

	const isVoucherPendente = signed && user?.travelVoucher && !user?.usedTravelVoucher;
	const skipRoute = ROUTES_SEM_GATE.some((r) => location.pathname.startsWith(r));
	const shouldArm = isVoucherPendente && !skipRoute && !globalLoader;

	useEffect(() => {
		if (!shouldArm) {
			setReveal(false);
			return undefined;
		}
		const timer = setTimeout(() => setReveal(true), REVEAL_DELAY_MS);
		return () => clearTimeout(timer);
	}, [shouldArm]);

	if (!reveal) return null;

	return (
		<RegisterModal
			open={true}
			onClose={() => {}}
			travelVoucherUser={user?.travelVoucher}
			mandatory={true}
		/>
	);
}

export default VoucherIdentificationGate;
